import { parseSlackBlocksToHTML } from './parseSlackBlocktoHtml';
import { parseSlackMarkdownText } from './parseSlackMarkdown';

export function renderSlackMessage(messagePayload: any): string {
  // 1. Check top-level blocks or nested additionalData blocks
  let blocks = messagePayload.blocks;

  if (!blocks && messagePayload.additionalData) {
    try {
      const parsedData = JSON.parse(messagePayload.additionalData);
      blocks = parsedData.blocks;
    } catch (e) {
      console.error('Failed to parse additionalData JSON', e);
    }
  }

  // Scenario A: Blocks exist -> Parse the JSON structure
  if (blocks && blocks.length > 0) {
    return parseSlackBlocksToHTML(blocks);
  }

  // Scenario B: Blocks are missing -> Fallback to parsing the text string
  if (messagePayload.text) {
    return parseSlackMarkdownText(messagePayload.text);
  }

  return '';
}
